import { render } from "./AppUnsavedChangesDialog.vue?vue&type=template&id=a6d73588"
import script from "./AppUnsavedChangesDialog.vue?vue&type=script&lang=js"
export * from "./AppUnsavedChangesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__